import { render, staticRenderFns } from "./PackageBase.vue?vue&type=template&id=3df0dd7c&scoped=true"
import script from "./PackageBase.vue?vue&type=script&lang=js"
export * from "./PackageBase.vue?vue&type=script&lang=js"
import style0 from "./PackageBase.vue?vue&type=style&index=0&id=3df0dd7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df0dd7c",
  null
  
)

export default component.exports